export class ParticipantItem {
    constructor() { }
    value:string;
    name:string;
}


// WEBPACK FOOTER //
// ./src/app/modules/mailing-list/models/participantItem.ts